import {State} from '@ispm-client/modules/bpmn-modeler/store/state';
import {createSelector, MemoizedSelector} from '@ngrx/store';
import {selectBpmnModelerState} from '@ispm-client/modules/bpmn-modeler/store/selectors/bpmn-modeler-state.selector';


const getSpinnerStatus = (state: State): boolean => state.spinnerStatus;

export const selectSpinnerStatus: MemoizedSelector<object, boolean> = createSelector(selectBpmnModelerState, getSpinnerStatus);
